import React from 'react';
import { useState } from "react";
import { Navbar, Nav } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import { ShowIfLoggedIn } from '../features/auth/auth_utils';
import { ShowIfNotLoggedIn } from '../features/auth/auth_utils';
import LogoutButton from './LogoutButton';
import WatchListModal from './WatchListModal';

export default function TopNavbar() {
  const [showModal, setShowModal] = useState(false);
  const [navigationURL, setNavigationURL] = useState('/watchlistSchemeSubstitute');
  const navigate = useNavigate();

  const handleWatchListSubmit = (data) => {
    setShowModal(false);
    console.log("*** handleWatchListSubmit, watchlist - ", data);
    navigate(navigationURL, {
      replace: true,
      state: data
    });
     window.location.reload();
  };

  return (
    <>
      <Navbar bg="light" expand="sm" className="shadow-sm fixed-top" style={{zIndex: 1050}}>
        <div className="container-fluid mw-100">
          <Navbar.Brand as={Link} className="mx-4 text-start" to="/"><b>Mutual Fund pNAV Calculator - Early Release</b></Navbar.Brand>
          <Nav className="mx-4">
            <Nav.Link as={Link} to="/" className="shadow">Home</Nav.Link>
            <ShowIfLoggedIn>
              <Nav.Link as={Link} to="/dashboard" className="shadow-sm me-2"><b>Tracked Schemes</b></Nav.Link>
              <Nav.Link as={Link} to="/GenAPIkey" className="shadow me-2"><i>Generate API key</i></Nav.Link>
              <Nav.Link onClick={() => { setNavigationURL('/userSchemesWatchList'); setShowModal(true); return true;}}><b>My WatchList</b></Nav.Link>
              <Nav.Link onClick={() => { setNavigationURL('/userSchemesWatchListSubstitute'); setShowModal(true); return true;}}><u>My WatchList & Substitutes</u></Nav.Link>
              <Nav.Link as={Link} to="/userFundPlanner" className="shadow me-2"><i>Select Funds</i></Nav.Link>
              <Nav.Link as={Link} to="/userFundSchemes2" className="shadow-sm me-2"><b>Selected Funds Schemes</b></Nav.Link>
              <LogoutButton />
            </ShowIfLoggedIn>
            <ShowIfNotLoggedIn>
              <Nav.Link as={Link} to="/login">Sign In</Nav.Link>
              <Nav.Link as={Link} to="/signup">Sign Up</Nav.Link>
            </ShowIfNotLoggedIn>
          </Nav>
        </div>
      </Navbar>
      <WatchListModal
          show={showModal}
          onHide={() => setShowModal(false)}
          newWatchlistOption={false}
          onSubmit={handleWatchListSubmit}
      />
    </>
  );
}

